define.alias("ember-cli-string-helpers/helpers/trim", "calendar/helpers/trim");